import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import moment from 'moment';
import cx from 'classnames';

import { imageCdnAsset } from 'lib/common/url-helpers';

const propTypes = {
  articles: PropTypes.instanceOf(List).isRequired,
};

const defaultProps = {
};

class Articles extends Component {
  constructor(props) {
    super(props);
    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
    this.state = {
      expanded: false,
    };
  }

  expand(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ expanded: !this.state.expanded });
  }

  collapse(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ expanded: false });
  }

  render() {
    const { articles } = this.props;
    // <object> is used here so that when stale images return 404 it will fall back to placeholder
    const articleCards = articles.map(article => (
      <div key={`${article._id}`} className="col-sm-6 font-family-overpass padding-right-30 padding-top-xs-20 padding-bottom-xs-20 padding-top-sm-0">
        <object
          data={article.image_url}
          height="130"
          width="130"
          className="float-left padding-bottom-40 padding-right-30 hidden-xs"
        >
          <img src={imageCdnAsset('/images/pw-placeholder.png')} alt="" />
        </object>
        <div className="text-weight-bold text-size-sm-18 text-size-xs-16 padding-bottom-10">
          <a href={article.url} target="_blank" rel="noopener noreferrer" className="text-color-dark-slate">{article.title}</a>
        </div>
        <div className="text-weight-book text-size-sm-16 text-size-xs-14">
          {moment(`${article.date_posted}`).format('MMMM D, YYYY')}
        </div>
      </div>
    )).toArray();

    const toggleClasses = cx({
      hidden: !this.state.expanded,
      visible: this.state.expanded,
    });
    const toggleButtonClasses = cx({
      hidden: this.state.expanded,
      visible: !this.state.expanded,
    });

    return (
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1">
          <div className="text-left-sm text-center-xs">
            <div className="padding-top-sm-40 padding-bottom-sm-40 padding-top-xs-20 padding-bottom-xs-10 text-weight-black text-size-sm-42 text-size-xs-24 text-color-dark-slate">IN THE NEWS</div>
          </div>
          {articleCards.slice(0, 4)}
          <div className={`row text-center padding-top-sm-20 padding-top-xs-40 padding-bottom-xs-40 ${toggleButtonClasses}`}>
            <span onClick={this.expand} className="btn-alternate btn-bp">VIEW MORE</span>
          </div>
          { articleCards.length > 4 &&
            <div className={toggleClasses}>
              {articleCards.slice(4, articleCards.length)}
              <div className="row text-center padding-top-sm-20 padding-top-xs-40 padding-bottom-xs-40">
                <span onClick={this.collapse} className="btn-alternate btn-bp">SHOW LESS</span>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

Articles.propTypes = propTypes;
Articles.defaultProps = defaultProps;
export default Articles;
